import store from '../../store'
import Storage from '@/services/storageLib'
import constants from '@/services/constants/constantStrings'
import { getVersionConfig } from '../version'
import Loader from './Loader'

class UpdateChatWidget {
  constructor() {
    this.version = ''
    this.updateScript = this.updateScript.bind(this)
    this.init = this.init.bind(this)
  }

  async init() {

    this.version = await getVersionConfig()

    // Remove the loader if present on the Screen
    const oldLoader = window.parent.document.getElementById(constants.NETOMI_LOADER)
    if (oldLoader) {
      setTimeout(() => {
        oldLoader.classList.add('net-removed')
        oldLoader.remove()
        store.dispatch(
          'toggleChatWindowStatus',
          Storage.getSessionStorageData(constants.SESSION_BOT_STATUS)
        )
        Storage.removeSessionStorageData(constants.SESSION_BOT_STATUS)
        store.dispatch('fetchHistory')
      }, 100)
    }
    return this.updateScript
  }

  async updateScript() {

    const currentVersion = await getVersionConfig()

    if(!currentVersion || currentVersion === this.version){
      return;
    }

    // Get the parent window as script will be removed from parent
    const parentWindow = window.parent
    const botRefId = store?.state?.botRefId
    const currentScript = parentWindow.document.querySelectorAll(
      `[botRefId="${botRefId}"]`
    )[0]
    // Create new Script
    const scriptTag = document.createElement('script')
    // Copy all the attributes to new script
    let attr = currentScript?.attributes
    for (let key in attr) {
      if (typeof attr[key] != 'function') {
        scriptTag.setAttribute(attr[key].name, attr[key].value)
      }
    }
    scriptTag.type = 'text/javascript'
    // eslint-disable-next-line no-undef
    scriptTag.onload = () => resolve()

    // Get the Attributes for the loader
    const color = store.state.widgetConfig?.theme?.color || constants.DEFAULT_COLOR
    const netomiChatWindow =
      parentWindow.document.getElementById('netomiChatWindow')
    const header = window.document.getElementsByClassName('widget-header')[0]
    const headerHeight = header.offsetHeight
    const netomiChatWindowAttributes = netomiChatWindow?.attributes
    const width = netomiChatWindow.offsetWidth
    const height = netomiChatWindow.offsetHeight
    Storage.setSessionStorageData(
      constants.SESSION_BOT_STATUS,
      store.state.isWindowMaximized
    )
    const updateTime = new Date().getTime();
    Storage.setSessionStorageData(
      constants.SESSION_BOT_UPDATED,
      updateTime
    )

    let loader = document.createElement('div')
    loader.setAttribute('id', constants.NETOMI_LOADER)
    loader.innerHTML = Loader(headerHeight, color)
    loader.setAttribute(
      netomiChatWindowAttributes['style'].name,
      netomiChatWindowAttributes['style'].value
    )
    loader.style.width = `${width}px`
    loader.style.height = `${height}px`
    // Remove current script and iframe
    currentScript.remove()
    netomiChatWindow.remove()
    // Start the loader
    parentWindow.document.body.appendChild(loader)
    // Add the new Script
    parentWindow.document.body.appendChild(scriptTag)
  }
}

export default new UpdateChatWidget()
